import type {
  Article,
  ArticleRatingProps,
  RatingResponse,
} from '../article.types';
import {getMockPublicItem} from '../get-item-list/api-mocks/apigee-response';
import {fetchService} from '../index';

export async function getPublicItem(id: string, language: string) {
  const path = `/public/item/${id}`;
  const queryParams = {
    language,
    switchItemLink: true,
  };
  //mocking for git push pre-hook for local environment pnpm run build
  if (
    process?.env?.TARGET_ENV === 'local' ||
    process?.env?.TARGET_ENV === 'work'
  ) {
    return getMockPublicItem(id, language);
  }
  const data: Article = await fetchService(
    path,
    'GET',
    queryParams,
    null,
    null,
  );

  return data;
}

export async function postArticleRating(
  id: number,
  language: string,
  helpful: boolean,
  note?: string,
) {
  const path = '/public/helpful';
  const body: ArticleRatingProps = {
    ip: '123',
    sessionId: '123',
    itemId: id,
    helpful: helpful,
    note: note || '',
    type: 'SEARCH',
  };
  const header = {
    'Content-Type': 'application/json',
  };
  const data: RatingResponse = await fetchService(
    path,
    'POST',
    {},
    header,
    body,
  );

  return data;
}
